/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Constant imports.
 */
import { NUMBERS } from 'src/app/constants/app.constants';

/**
 * Basic footer for the multiple buttons like primary and secondary.
 */
@Component({
  selector: 'app-multiple-button-footer',
  templateUrl: './multiple-button-footer.component.html',
  styleUrls: ['./multiple-button-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultipleButtonFooterComponent {

  /**
   * Target information.
   */
  @Input() targetInfo;

  /**
   * Emit the template card button cta.
   */
  @Output() emitCtaTarget: EventEmitter<any> = new EventEmitter();

  /**
   * Numbers constant.
   */
  public numbers = NUMBERS;

  /**
   * Emit the template card button cta.
   */
  ctaTarget(target: any): void {
    this.emitCtaTarget.emit(target);
  }
}
